import axios from "axios";
import { ExpandedRatingOptions, RatingAssumption, SaleMethod, SecurityType, TaxDesignation, USState } from "../services/utils/primary-constants";

// @ts-ignore
const SPLINE_DEAL_BUILDER_ENDPOINT = process.env.REACT_APP_DEALBUILDER_URL;

export type ApiResponse<T> = ApiError | T;

export interface ApiError {
    error: string,
    message: string,
    detail: string | undefined,
}

export type PostDealBuilderInput = {
    parAmount: number,
    callDate: number | "",
    marketConditionsDate: number,
    ratingAssumption: RatingAssumption,
    saleMethod: SaleMethod,
    securityType: SecurityType,
    stateOfIssuance: USState,
    taxDesignation: TaxDesignation,
    bondInsurance: boolean,
    stateEnhancement: boolean,
    enhancedRating: ExpandedRatingOptions | "",
    couponUserInput: boolean,
    years_to_maturity_list: number[],
    coupon_list: number[],
    par_amount_list: number[],
    term_bonds_list: boolean[],
};

export type PostDealBuilderOutput = {
    data: {
        index: number,
        AAA: number,
        spread: number,
        coupon: number
    }[]
};

const GENERIC_API_ERROR: ApiError = {
	error: "generic-error",
	message: "We couldn't connect to our servers.",
	detail: "We couldn't connect to our servers."
};

export default class DealBuilderAPI {

    public static async getPredictions(token: string, payload: PostDealBuilderInput): Promise<ApiResponse<PostDealBuilderOutput>> {
        try {
            const config = { headers: { Authorization: `Bearer ${token}` } };
            const { data } = await axios.post(SPLINE_DEAL_BUILDER_ENDPOINT, payload, config);
            return data;
        } catch (_e) {
            console.log(_e)
            return GENERIC_API_ERROR;
        }
    }

}
